import { Box, Collapse, Flex, Text } from '@chakra-ui/react'
import { generalIllnessExamField, VisitModality } from '@hb/shared'
import { useState } from 'react'
import { useField } from 'react-final-form'
import { FormElement } from '../../../../components/forms/Input'
import { SectionLabel } from '../../SectionLabel'

// §2.6: Collapsible general illness exam sub-section for non-routine in-person visits. Tier 2.
// Hidden when visit modality is telehealth (physical examination not possible remotely).
export const GeneralIllnessExamInput = () => {
  const [isOpen, setIsOpen] = useState(false)

  const {
    input: { value: modality },
  } = useField<VisitModality | undefined>('data.visitLocation.modality', {
    subscription: { value: true },
  })

  const isTelehealth = modality === 'telehealth-video' || modality === 'telehealth-audio-only'

  if (isTelehealth) return null

  return (
    <Box w="100%" data-child-name="data.generalIllnessExam" px={4} py={3}>
      <Flex
        align="center"
        justify="space-between"
        cursor="pointer"
        py={2}
        px={1}
        onClick={() => setIsOpen(v => !v)}
        _hover={{ bg: 'gray.50' }}
        borderRadius={4}>
        <SectionLabel>General Illness Exam</SectionLabel>
        <Text fontSize="xs" color="gray.500">
          {isOpen ? 'Collapse ▲' : 'Expand ▼'} · Tier 2
        </Text>
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        <Box pt={1}>
          <FormElement
            root
            showName={false}
            field={generalIllnessExamField}
            name="data.generalIllnessExam"
          />
        </Box>
      </Collapse>
    </Box>
  )
}
